<template>
  <el-dialog title='改价申请' :visible.sync='dialogVisible' width='clamp(680px, 75%,1280px)'>
    <div>
      <AdjustPricePanel
        ref='applyEditPricePanel'
        v-if='formData.next_quote'
        :show-multi-price='priceTypeMap.multi'
        :show-single-price='priceTypeMap.single'
        :show-mixed-price='priceTypeMap.mixed'
        :quote-info.sync='formData.next_quote'
        :title='`本期预估`'
        :edit-price='true'
        :platform-type='platformType' />
      <div style='display: flex;justify-content: center;align-items: center;'>
        <el-button type='primary' @click='handleSaveApply' :disabled='loading' :loading='loading' round>确认改价
        </el-button>
      </div>
      <div>
        <el-link type='primary' @click='showHistory'>查看已申请的改价记录</el-link>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import AdjustPricePanel from '@/pages/publication/adjust/AdjustPricePanel.vue'
import plcMap from '@/json/plc.json'

export default {
  name: 'PlcEditPriceApply',
  components: { AdjustPricePanel },
  computed: {
    //报价方式：品类报价（1：n）；类目报价
    priceTypeMap() {
      const customPriceMap = plcMap.customPriceMap
      return customPriceMap[this.platformType] || {
        'showLast': true,
        'multi': true,
        'single': true,
        'mixed': true
      }
    }
  },
  data() {
    return {
      loading: false,
      platformType: null,
      formData: {
        id: null,

        next_quote: {},
        real_quote: {}
      },
      dialogVisible: false,
      dialogFormVisible: false,
      formLabelWidth: '120px'
    }
  },
  methods: {
    edit(data, setting) {
      this.loading = false
      this.platformType = setting.type
      this.dialogVisible = true
      this.formData.id = data.id
      this.formData.next_quote = data.status === 2 ? data.real_quote : data.next_quote
      // this.formData.real_quote = data.real_quote
    },
    async handleSaveApply() {
      //修改报价(只改本期预估价格-20260507)
      const data = {
        id: this.formData.id,
        // current_quote: this.formData.current_quote,
        next_quote: this.formData.next_quote
      }
      this.loading = true
      const info = await this.$api.saveQuoteItem(data)
      if (info)
        this.msgSuccess('已提交改价申请，请等待审核！！')


      this.dialogVisible = false
    },
    showHistory() {
      // const { href } = this.$router.resolve({
      //   name: 'plc_item', params: { id: this.formData.id }
      // })
      const windowTarget = `plc_item_edit_price_${this.formData.id}`
      // const windowTarget = "_blank"
      const windowFeatures = 'left=50,top=50,width=1240,height=980'
      this.$utils.safeOpenWindow(this, {
        name: 'plc_item', params: { id: this.formData.id }
      }, windowTarget, windowFeatures)


    }
  }
}
</script>
<style scoped>

</style>
